import * as React from "react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import { Check as CheckIcon } from "@papier/ui/components/icons";
import type { VariantProps } from "class-variance-authority";

import { cn } from "@papier/ui/lib/utils";
import { toggleVariants } from "@papier/ui/components/ui/toggle";

function Checkbox({
  className,
  variant = "default",
  size = "default",
  children,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  variant?: "default" | "segmented";
  size?: VariantProps<typeof toggleVariants>["size"];
}) {
  const indicator = (
    <CheckboxPrimitive.Indicator
      data-slot="checkbox-indicator"
      className="flex items-center justify-center text-current transition-none"
    >
      <CheckIcon className="size-3.5" />
    </CheckboxPrimitive.Indicator>
  );
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      data-variant={variant}
      className={cn(
        variant === "segmented"
          ? toggleVariants({ variant, size })
          : "peer size-4 shrink-0 rounded-full border border-input shadow-xs transition-shadow outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-primary",
        className,
      )}
      {...props}
    >
      {variant === "segmented" ? (
        <>
          {children}
          <span aria-hidden="true" className="flex size-4 shrink-0 items-center justify-center">
            {indicator}
          </span>
        </>
      ) : (
        indicator
      )}
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
